/*
 * @Description: 
 * @Author: ADCannon
 * @Date: 2023-02-10 11:00:56
 * @FilePath: \GamerSky.Valorant\src\views\index\index.js
 */

import Vue from 'vue'
import App from './index.vue'
// import router from './router'
// import store from './store'

import ajax from "../../assets/js/axios.config"
import utils from "../../assets/js/utils"
import bussiness from "../../assets/js/bussiness"

import "../../assets/css/reset.css"

import "../../assets/js/directive"
import toast from "../../components/Toast"

import VueLazyload from "vue-lazyload";
import { Popup } from "vant";
import 'vant/lib/index.css';
import "../../assets/scss/main.scss"


Vue.prototype.$ajax = ajax;
Vue.prototype.$utils = utils;
Vue.prototype.$bussiness = bussiness;

Vue.use(toast);
Vue.use(Popup);

Vue.use(VueLazyload, {
    throttleWait: 100
});

Vue.config.productionTip = false

// 微信二次分享
bussiness.WeChatShare();

// utils.openWithNewWindow("https://www.gamersky.com/", {
//     a:1,
//     b:2
// })

// 全站访问统计
// bussiness.SetHits(15);

new Vue({
    //   router,
    //   store,
    render: h => h(App)
}).$mount('#app')